import { useContext, useEffect, useState } from "react";
import { t } from "i18next";
import { Button, Card } from "react-bootstrap";
import { showErrorMessage } from "@beeldit/core/helpers/messagesHelper";
import { useLocation, useNavigate } from "react-router-dom";
import useDetailsByPageableAction from "../actions/detailsByPageable/useDetailsByPageableAction";
import { DetailsActionContext } from "../actions/details/DetailsActionContext";
import PageLoadErrorState from "@bloonde/cms/cms-pages/components/PageLoadErrorState";
import useRepairMissingSections from "@bloonde/cms/cms-pages/actions/repairMissingSections/useRepairMissingSections";

function PageEditionByPageablePage(props: {
  pageableId: number;
  pageableType: string;
}) {
  const { pageableId, pageableType } = props;
  const navigate = useNavigate();
  const location = useLocation();

  const {
    getFunction,
    onSubmitFunction,
    actionTemplate: detailsActionTemplate,
  } = useDetailsByPageableAction(pageableId, pageableType);
  const { pageLoadError } = useContext(DetailsActionContext);
  const { repairing, repairMissingSections } = useRepairMissingSections();
  const [repairingSectionId, setRepairingSectionId] = useState<number | null>(null);

  const listPath = location.pathname.replace(/\/[^/]+$/, "");
  const retryLoad = () => getFunction(pageableId, pageableType);
  const navigateToList = () => navigate(listPath);
  const canRepairPage = Boolean(pageLoadError?.canRepairMissingSections);
  const reloadPage = () => window.location.reload();
  const repairSection = async (section: any) => {
    const endpoint =
      section?.repairEndpoints?.byPageableId ??
      `pages/byPageable/${pageableId}/sections/${section.sectionId}/repair-content`;

    if (!endpoint) {
      showErrorMessage("No se encontro un endpoint de reparacion para esta seccion");
      return;
    }

    setRepairingSectionId(section.sectionId);

    try {
      await repairMissingSections(pageableId, { endpoint }, reloadPage);
    } finally {
      setRepairingSectionId(null);
    }
  };
  const repairPage = () =>
    repairMissingSections(
      pageableId,
      { endpoint: `pages/byPageable/${pageableId}/repair-missing-sections` },
      reloadPage
    );

  useEffect(() => {
    if (!pageableId && pageableType) return;
    getFunction(pageableId, pageableType);
  }, [pageableId, pageableType]);

  if (!pageableId && !pageableType) return null;

  return (
    <Card>
      <Card.Body>
        <div className="PageEditContainer">
          {pageLoadError ? (
            <PageLoadErrorState
              title={pageLoadError.title}
              detail={pageLoadError.detail}
              onRetry={retryLoad}
              onBack={navigateToList}
              onRepair={canRepairPage ? repairPage : undefined}
              repairing={repairing}
              repairableSections={pageLoadError.repairableSections}
              onRepairSection={repairSection}
              repairingSectionId={repairingSectionId}
            />
          ) : (
            detailsActionTemplate
          )}
        </div>
      </Card.Body>

      {!pageLoadError ? (
        <Card.Footer className="d-flex py-4">
          <Button variant="primary" size="lg" className="ms-auto" onClick={onSubmitFunction}>
            {t("save_changes")}
          </Button>
        </Card.Footer>
      ) : null}
    </Card>
  );
}

export default PageEditionByPageablePage;
